export default "__VITE_ASSET__BsB0eEZs__"